<template>
  <wa-modal-frame
    :is-showing="isShowing"
    has-actions
    @close-modal="closeModal"
  >
    <div slot="content">
      <section
        style="
          margin-inline: calc(-1 * var(--card-horizontal-padding));
          margin-top: calc(-1 * var(--card-vertical-padding));
          border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
          overflow: hidden;
        "
      >
        <img
          src="https://img.fortawesome.com/1ce05b4b/wa-modal-promo.png"
          alt="Web Awesome Logo Graphic"
          style="width: 100%; height: 100%; object-fit: cover"
        />
      </section>
      <section class="text-left">
        <h2 class="margin-top-md margin-bottom-2xs">Web Awesome has landed!</h2>
        <p>
          Explore the biggest and best open-source library of meticulously designed, highly customizable, and framework-agnostic UI components. And for a limited time, get 20% off a Pro subscription.
        </p>
      </section>
    </div>
    <div
      slot="actions"
      class="display-flex flex-column flex-items-center tablet:flex-row tablet:flex-content-between"
      style="--button-margin-bottom: 0; gap: var(--spacing-lg)"
    >
      <a href="https://webawesome.com/?utm_source=fontawesome&utm_medium=modal&utm_campaign=launch" class="button block" target="_blank">
        <i class="fa-solid fa-xl fa-arrow-up-right-from-square margin-right-sm"></i>
        Explore Web Awesome
      </a>
      <a href="https://webawesome.com/purchase?utm_source=fontawesome&utm_medium=modal&utm_campaign=launch"
        class="button block"
        style="
          --button-color: var(--fa-navy);
          --button-background: #FFAF99;
          --button-hover-background: #F36944;
          --button-hover-border-color: var(--fa-navy);
        "
        target="_blank"
      >
        <i class="fa-solid fa-xl fa-rocket-launch margin-right-sm"></i>
        20% Off Launch Sale
      </a>
    </div>
  </wa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'

  export default {
    name: 'ModalWebAwesomeAnnouncement',

    mixins: [ModalFrameMixin],

    methods: {
      closeModal() {
        this.$emit('close-modal')
      }
    }
  }
</script>
